import { IActionContext } from '../helpers/ActionContext';
import { L10n } from '../L10n/L10n';
import { Module } from '../Module';
import { ServerUsers } from '../resources/ServerUsers';
import { IError } from '../ServerApi/types/IError';
import { IPersonalAccessToken } from '../ServerApi/types/IPersonalAccessToken';
import { IResult } from '../ServerApi/types/IResponse';
import { ConfirmActionDialog, IConfirmActionDialogInstance } from './ConfirmActionDialog';
import { ContentActionNotification } from './ContentActionNotification';
import { ModalService } from './ModalService';

export class DeletePersonalAccessTokenAction {

  public static $inject = [
    '$translate',
    'ConfirmActionDialog',
    'ContentActionNotification',
    'ServerUsers'
  ];

  constructor(
    private $translate: ng.translate.ITranslateService,
    private ConfirmActionDialog: ConfirmActionDialog,
    private ContentActionNotification: ContentActionNotification,
    private ServerUsers: ServerUsers) { }

  public execute(token: IPersonalAccessToken, userId: string, context: IActionContext): ng.IPromise<IResult> {
    return this.ConfirmActionDialog.open({
      scope: context.scope.$new(),
      title: this.$translate.instant('deleteMessage'),
      bodyText: this.$translate.instant('personalAccessTokenConfirmDelete', {NAME: L10n.elideIfLong(token.clientId)}),
      position: ModalService.anchoredTo(context.targetElement),
      actionName: this.$translate.instant('deleteMessage'),
      action: (dialogInstance: IConfirmActionDialogInstance) => {
        return this.ServerUsers.deletePersonalAccessToken(userId, token.clientId)
          .then((result: IResult) => {
            if (result.errors && result.errors.length) {
              const errorMessage = this.errorMessageFor(result.errors[0]);
              dialogInstance.showErrorMessage(errorMessage);
            } else {
              this.ContentActionNotification.notifySuccess(
                this.$translate.instant('personalAccessTokenDeleteDeviceSuccess', {NAME: L10n.elideIfLong(token.clientId)}));
            }
            return result;
          });
      }
    }).result;
  }

  private errorMessageFor(error: IError) {
    return this.$translate.instant('errorUnknown');
  }

}

Module.instance().service('DeletePersonalAccessTokenAction', DeletePersonalAccessTokenAction);
